import * as angular from "angular";
import {IController} from "angular";
import {ContactPersonModel} from "../../models/contact-person.model";

export class ContactPersonListItemComponent implements IController {
  contact: ContactPersonModel;
  index: number;
  canRemove?: boolean;
  onChange: Function;
  onRemove: Function;

  constructor() {
  }

  $onInit() {
  }

  onFieldChange() {
    this.onChange();
  }

  onPhoneChange(phone) {
    this.contact.phoneNumber = phone;
    this.onChange();
  }

  onRemoveClick() {
    this.onRemove({index: this.index});
  }

}

angular
  .module('bringoz.admin.commons')
  .component('contactPersonListItem', {
    bindings: {
      contact: '<',
      index: '<',
      canRemove: '<?',
      onChange: '&',
      onRemove: '&'
    },
    template: require('./contact-person-list-item.html').default,
    controller: ContactPersonListItemComponent
  });
